module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-6.4eb5218d.png";